import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'range-picker',
    templateUrl: './range-picker.component.html',
    styleUrls: ['./range-picker.component.scss']
})
export class RangePickerComponent implements OnInit {
    @Input() selectedDay: number = 30;
    @Input() selectedDays: number = 30;
    @Input() hasCustom: boolean = false;
    @Input() selectedMonths: number[][] = [];
    @Input() selectedYear: number = new Date().getFullYear() - 2000;
    @Input() addYears: number = 0;
    @Input() yearsRange: number[];
    @Output() change: EventEmitter<any> = new EventEmitter();
    currentMonth: number = new Date().getMonth();
    currentYear: number = new Date().getFullYear() - 2000;
    visibleYears: number[] = [];
    months: string[] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    id: number = Math.random();

    ngOnInit() {
        this.viewYear(this.selectedYear);
    }

    viewYear(year: number) {
        if (!this.yearsRange)
            this.yearsRange = this.years;
        this.selectedYear = year;
        let selectedYear = this.selectedYear;
        this.visibleYears = [this.selectedYear];
        while (this.canAddMoreYears) {
            if (this.yearsRange.includes(selectedYear + 1) && !this.visibleYears.includes(selectedYear + 1))
                this.visibleYears.push(selectedYear + 1);
            if (this.yearsRange.includes(selectedYear - 1) && !this.visibleYears.includes(selectedYear - 1) && this.canAddMoreYears)
                this.visibleYears.unshift(selectedYear - 1);
            if (this.yearsRange.includes(selectedYear + 2) || this.visibleYears.includes(selectedYear + 1))
                selectedYear += 1;
            else
                selectedYear -= this.visibleYears.includes(selectedYear - 1) ? 2 : 1;
        }
    }

    get years(): number[] {
        let years: number[] = [];
        if (this.addYears < 0) {
            for (var i = 0; i >= this.addYears; i--)
                years.push(this.selectedYear + i);
        }
        else {
            for (var i = 0; i <= this.addYears; i++)
                years.push(this.selectedYear + i);
        }
        return years;
    }

    get canAddMoreYears() {
        return this.visibleYears.length < 4 && this.visibleYears.length < this.yearsRange.length;
    }

    getMonthIndex(month: number, year: number) {
        return this.selectedMonths.findIndex(m => m[0] == month && m[1] == year);
    }

    selectMonth(month: number, year: number) {
        let ix = this.getMonthIndex(month, year);
        if (ix < 0) {
            if (this.addYears < 0 && this.selectedDays > 0) {
                let date = new Date();
                date.setDate(date.getDate() - this.selectedDays);
                if (month >= date.getMonth() && year >= date.getFullYear() - 2000)
                    return;
            }
            this.selectedMonths.push([month, year]);
        }
        else
            this.selectedMonths.splice(ix, 1);
        this.change.emit();
    }

    selectDays(e: any, days: number) {
        if (e.currentTarget.checked) {
            if (this.addYears < 0) {
                let date = new Date();
                date.setDate(date.getDate() - days);
                for (let selected of this.selectedMonths) {
                    if (selected[0] >= date.getMonth() && selected[1] >= date.getFullYear() - 2000) {
                        e.preventDefault();
                        return;
                    }
                }
            }
            this.selectedDays = days;
        }
        else
            this.selectedDays = null;
        if (this.addYears > 0)
            this.hasCustom = false;
        this.change.emit();
    }

    selectCustom(e: any) {
        this.hasCustom = e.currentTarget.checked;
        if (this.hasCustom && this.addYears > 0)
            this.selectedDays = null;
    }

    getSelectedMonths() {
        let allMonths = [];
        for (let month of this.selectedMonths)
            allMonths.push(`20${month[1]}-${month[0] < 9 ? '0' : ''}${month[0] + 1}-01`);
        return allMonths;
    }

    setData(data: RangePickerComponent) {
        this.selectedDay = data.selectedDay;
        this.selectedDays = data.selectedDays;
        this.hasCustom = data.hasCustom;
        this.selectedMonths = data.selectedMonths;
        this.selectedYear = data.selectedYear;
        this.addYears = data.addYears;
        this.yearsRange = data.yearsRange;    
    }
}